import { authManager } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';

type RemoteEnv = 'local' | 'stag' | 'prod';

type Remote = {
  url: string;
  loadPromise: Promise<boolean> | null;
};

const remoteUrls: Record<RemoteEnv, string> = {
  local: 'http://localhost:4201',
  stag: 'https://bi-mfe.stag.dixa.io',
  prod: 'https://bi-mfe.dixa.io',
};

/**
 * The environment. Defaults to either `stag` or `prod` depending on the current
 * root Dixa environment. Assign it to `local` if you need to use a local
 * instance of the Miuros applications.
 */
//const env: RemoteEnv = 'local';
const env: RemoteEnv = config.environment.startsWith('stag') ? 'stag' : 'prod';

const remote: Remote = {
  url: `${remoteUrls[env]}/remoteEntry.mjs`,
  loadPromise: null,
};

const getCurrentToken = async () => {
  const authData = await authManager.getAuthData();
  return authData?.access_token;
};

const doLoad = async (rootUrl: string): Promise<boolean> => {
  try {
    // eslint-disable-next-line no-unsanitized/method
    const container = await import(/* webpackIgnore:true */ remote.url);
    // eslint-disable-next-line no-undef
    await __webpack_init_sharing__('angular');
    await container.init(__webpack_share_scopes__.angular);

    const moduleFactory = await container.get('./App');
    const module = await moduleFactory();

    module.bootstrap(env, rootUrl, getCurrentToken);
  } catch {
    return false;
  }

  return true;
};

export const loadIntelligenceRemote = (rootUrl: string): Promise<boolean> => {
  if (!remote.loadPromise) {
    remote.loadPromise = doLoad(rootUrl);
  }

  return <Promise<boolean>>remote.loadPromise;
};
